import { useContext, useEffect } from 'react';
import { PageTitleContext } from './contexts/usePageTitle.js';

function useCustomPageTitle(customTitle: string) {
  const { setPageTitleContext } = useContext(PageTitleContext);

  useEffect(() => {
    setPageTitleContext(customTitle);
    return () => setPageTitleContext(null);
  }, [customTitle, setPageTitleContext]);
}

export default useCustomPageTitle;
